// extracted by mini-css-extract-plugin
export var contained = "StackedDisplay-module--contained--6ff3b";
export var heading = "StackedDisplay-module--heading--e00e1";
export var stackeddisplay = "StackedDisplay-module--stackeddisplay--d69d6";
export var summaries = "StackedDisplay-module--summaries--8d8c8";
export var summary = "StackedDisplay-module--summary--429d9";